
//client\src\flow\examples\sgpitsExample.js

export const SGPITS_EXAMPLE = {
  name: "SGPITS - Protótipo de Navegação Integrada",
  url: "sgpits",
  type: "navigation",
  logo: "https://kahrvoefxxpexxobnyvv.supabase.co/storage/v1/object/public/flow-logos/logos/logo_sgpits.png",
  formConfig: {
    title: "SGPITS - Setor de Gestão da Pesquisa e Inovação Tecnológica em Saúde",
    subtitle: "HC-UFU/EBSERH - Facilitador de Acesso à Informação\n⚠️ PROTÓTIPO EXPERIMENTAL",
    urgentPhone: "",
    email: "",
    successMessage: "",
    settings: {
      showProgressBar: false,
      requireConfirmation: false,
      generateProtocol: false,
      sendEmail: false,
      navigationMode: "tree"
    },
    steps: [
      // NÍVEL 0 - Principal
      {
        id: "home",
        title: "SGPITS - Facilitador de Acesso",
        icon: "Home",
        type: "navigation",
        level: 0,
        showBreadcrumbs: false,
        showAISearch: true,
        fields: [
          {
            id: "disclaimer-info",
            type: "info",
            label: "⚠️ Protótipo Experimental",
            description: "Este é um PROTÓTIPO facilitador para acessar informações frequentemente consultadas do HC-UFU/EBSERH. NÃO substitui os canais oficiais. Para informações completas, sempre consulte os sites oficiais.",
            icon: "AlertCircle"
          },
          {
            id: "main-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "ugpesq",
                type: "navigate",
                label: "UGPESQ",
                description: "Unidade de Gestão da Pesquisa\n\nLinks e informações úteis para pesquisadores. Acesso a documentos, modelos, sistema Rede de Pesquisa e orientações.",
                emoji: "📘",
                targetStep: "ugpesq-main",
                variant: "primary"
              },
              {
                id: "ugits",
                type: "navigate",
                label: "UGITS",
                description: "Unidade de Gestão da Inovação Tecnológica em Saúde\n\nInformações sobre inovação, ferramentas digitais, propriedade intelectual e programas de fomento.",
                emoji: "💡",
                targetStep: "ugits-main",
                variant: "success"
              },
              {
                id: "biblioteca",
                type: "navigate",
                label: "BIBLIOTECA",
                description: "Serviço de Biblioteca do HC-UFU/EBSERH\n\nLinks para bases de dados, treinamentos e serviços bibliotecários.",
                emoji: "📚",
                targetStep: "biblioteca-main",
                variant: "info"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: false,
          showNext: false,
          showHome: false
        }
      },
      // NÍVEL 1 - UGPESQ Principal
      {
        id: "ugpesq-main",
        title: "UGPESQ - Unidade de Gestão da Pesquisa",
        description: "Links e informações úteis para pesquisadores",
        icon: "Book",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ugpesq-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "ugpesq-sobre",
                type: "navigate",
                label: "Sobre a UGPESQ e Infraestrutura",
                description: "Informações sobre estrutura física, equipamentos disponíveis, notícias e eventos científicos.",
                emoji: "📋",
                targetStep: "ugpesq-sobre"
              },
              {
                id: "ugpesq-docs",
                type: "navigate",
                label: "Orientações e Documentação para Pesquisa",
                description: "Modelos de documentos, fluxogramas, manuais da Plataforma Brasil, Sistema Rede de Pesquisa e normativas.",
                emoji: "📝",
                targetStep: "ugpesq-docs"
              },
              {
                id: "ugpesq-patrocinada",
                type: "navigate",
                label: "Pesquisa Patrocinada e Ensaios Clínicos",
                description: "Informações sobre estudos financiados que acontecem no HC-UFU/EBSERH.",
                emoji: "💼",
                targetStep: "ugpesq-patrocinada"
              },
              {
                id: "ugpesq-apoio",
                type: "navigate",
                label: "Núcleo de Apoio ao Pesquisador",
                description: "Assessoria estatística, orientação metodológica para residentes, acesso a bases de dados e treinamentos.",
                emoji: "🎓",
                targetStep: "ugpesq-apoio"
              },
              {
                id: "ugpesq-cursos",
                type: "navigate",
                label: "Cursos e Capacitações em Pesquisa",
                description: "Cursos online gratuitos Fiocruz e UNA-SUS. ATENÇÃO: alguns cursos têm prazo limitado de inscrição!",
                emoji: "📚",
                targetStep: "ugpesq-cursos"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGPESQ Sobre
      {
        id: "ugpesq-sobre",
        title: "Sobre a UGPESQ e Infraestrutura",
        description: "Estrutura física e recursos disponíveis",
        icon: "Building",
        type: "navigation",
        level: 2,
        parentStep: "ugpesq-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ugpesq-sobre-navigation",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "estrutura-fisica",
                type: "contact",
                label: "Estrutura Física e Equipamentos",
                description: "INFRAESTRUTURA DISPONÍVEL:\n• Salas especializadas e laboratório\n• Consultório para participantes\n• Ambulatório de Pesquisa Sala 32\n• 2 centrífugas, 2 ultrafreezers -80°C\n• Monitores multiparâmetro\n• Equipamentos de emergência",
                emoji: "🏛️",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20😊%0A%0AEstava%20navegando%20pelo%20sistema%20SGPITS%20e%20fiquei%20interessado(a)%20em%20conhecer%20melhor%20a%20*estrutura%20física%20e%20equipamentos*%20da%20UGPESQ.%0A%0AGostaria%20de%20saber:%0A•%20Como%20posso%20agendar%20uma%20visita%20técnica?%0A•%20Existe%20possibilidade%20de%20utilizar%20os%20equipamentos%20para%20minha%20pesquisa?%0A•%20Quais%20são%20os%20procedimentos%20para%20reserva%20dos%20espaços?%0A%0AMeu%20nome%20é:%20%0AMinha%20pesquisa%20é%20sobre:%20%0A%0ADesde%20já%20agradeço%20a%20atenção!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  phone: "(34) 3218-2323"
                }
              },
              {
                id: "noticias-eventos",
                type: "navigate",
                label: "Notícias e Eventos Científicos",
                description: "Acompanhe notícias sobre pesquisas, eventos e workshops científicos.",
                emoji: "📰",
                targetStep: "ugpesq-noticias"
              },
              {
                id: "cadastro-pesquisadores",
                type: "link",
                label: "Cadastro de Pesquisadores Interessados",
                description: "Faça parte do banco de dados de pesquisadores do HC-UFU.",
                emoji: "📝",
                url: "http://bit.ly/pesquisadores-hc-ufu"
              },
              {
                id: "site-ugpesq",
                type: "link",
                label: "Site Oficial UGPESQ (Gov.br)",
                description: "Acesse o site institucional oficial para informações completas.",
                emoji: "🌐",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/unidade-de-gestao-da-pesquisa"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGPESQ",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - UGPESQ Notícias
      {
        id: "ugpesq-noticias",
        title: "Notícias e Eventos Científicos",
        description: "Divulgação científica e eventos",
        icon: "Bell",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-sobre",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ugpesq-noticias-list",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "podcast-hchange",
                type: "link",
                label: "Podcast HChange - Lançamento",
                description: "Notícia sobre o lançamento do podcast oficial (05/07/2023)",
                emoji: "🎙️",
                url: "https://comunica.ufu.br/noticias/2023/07/hospital-de-clinicas-da-ufu-lanca-podcast-hchange"
              },
              {
                id: "ciencia-pe-ouvido",
                type: "link",
                label: "Ciência ao Pé do Ouvido",
                description: "Episódio sobre pesquisa e inovação em saúde (12/09/2023)",
                emoji: "🎧",
                url: "https://comunica.ufu.br/noticias/2023/09/pesquisa-e-inovacao-em-saude-sao-tema-do-ciencia-ao-pe-do-ouvido"
              },
              {
                id: "profissionais-podcast",
                type: "link",
                label: "Profissionais em Podcast",
                description: "Participação em podcast externo (15/09/2023)",
                emoji: "🎤",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/comunicacao/noticias/profissionais-do-hc-ufu-participam-de-podcast-sobre-pesquisa-e-inovacao-em-saude"
              },
              {
                id: "workshop-wepit",
                type: "link",
                label: "Workshop WEPIT 2023",
                description: "Evento anual de Ensino, Pesquisa e Inovação (22/09/2023)",
                emoji: "📅",
                url: "https://eventos.ufu.br/hcu/wepit/2023/09"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGPESQ Documentação
      {
        id: "ugpesq-docs",
        title: "Orientações e Documentação",
        description: "Documentos, modelos e orientações",
        icon: "FileText",
        type: "navigation",
        level: 2,
        parentStep: "ugpesq-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ugpesq-docs-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "dados-estatisticos",
                type: "link",
                label: "Solicitação de Dados Estatísticos",
                description: "Formulário para solicitar dados do HC-UFU\nPrazo: até 30 dias",
                emoji: "📊",
                url: "http://bit.ly/form_ugiaest"
              },
              {
                id: "rede-pesquisa",
                type: "navigate",
                label: "Sistema Rede de Pesquisa EBSERH",
                description: "Sistema obrigatório para cadastro de pesquisas\nTodos os projetos devem ser cadastrados",
                emoji: "🖥️",
                targetStep: "ugpesq-rede-pesquisa"
              },
              {
                id: "modelos-docs",
                type: "navigate",
                label: "Modelos de Documentos",
                description: "Templates padronizados EBSERH\nGoogle Docs editável",
                emoji: "📄",
                targetStep: "ugpesq-modelos"
              },
              {
                id: "fluxogramas",
                type: "navigate",
                label: "Fluxogramas de Processo",
                description: "Diagramas visuais do passo a passo\nEtapas 1, 2 e 3",
                emoji: "📈",
                targetStep: "ugpesq-fluxogramas"
              },
              {
                id: "manuais",
                type: "navigate",
                label: "Manuais Técnicos",
                description: "Manuais e normativas\nResoluções CNS e Plataforma Brasil",
                emoji: "📚",
                targetStep: "ugpesq-manuais"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGPESQ",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - Rede de Pesquisa EBSERH
      {
        id: "ugpesq-rede-pesquisa",
        title: "Sistema Rede de Pesquisa EBSERH",
        description: "Sistema obrigatório de cadastro",
        icon: "Database",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-docs",
        showBreadcrumbs: true,
        fields: [
          {
            id: "rede-pesquisa-info",
            type: "info",
            label: "⚠️ CADASTRO OBRIGATÓRIO",
            description: "Todos os projetos de pesquisa desenvolvidos no HC-UFU devem ser cadastrados na Rede de Pesquisa EBSERH.",
            icon: "AlertCircle"
          },
          {
            id: "rede-pesquisa-navigation",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "acesso-sistema",
                type: "link",
                label: "Acessar o Sistema",
                description: "Portal de login da Rede de Pesquisa",
                emoji: "🔗",
                url: "https://sig.ebserh.gov.br/redepesquisa/"
              },
              {
                id: "manual-sistema",
                type: "link",
                label: "Manual do Pesquisador V.3.2",
                description: "Tutorial completo com screenshots",
                emoji: "📖",
                url: "https://sig.ebserh.gov.br/redepesquisa/app/Rede_Pesquisa_Manual_do_Pesquisador_2021_v2.pdf"
              },
              {
                id: "prerequisitos",
                type: "navigate",
                label: "Pré-requisitos para Cadastro",
                description: "ORCID e Currículo Lattes obrigatórios",
                emoji: "✅",
                targetStep: "ugpesq-prerequisitos"
              },
              {
                id: "suporte-cadastro",
                type: "contact",
                label: "Suporte para Cadastro",
                description: "Dúvidas sobre o sistema",
                emoji: "❓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🖥️%0A%0APreciso%20de%20ajuda%20com%20o%20*cadastro%20na%20Rede%20de%20Pesquisa%20EBSERH*.%0A%0A❓%20*Minha%20dúvida%20é:*%0A[%20]%20Como%20criar%20meu%20acesso%0A[%20]%20Como%20cadastrar%20um%20projeto%0A[%20]%20Erro%20no%20sistema%0A[%20]%20Documentação%20necessária%0A[%20]%20Outro:%20%0A%0A📋%20*Sobre%20meu%20projeto:*%0A•%20Título:%20%0A•%20Área:%20%0A•%20Status%20CEP:%20%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  phone: "(34) 3218-2323"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // Pré-requisitos do Sistema
      {
        id: "ugpesq-prerequisitos",
        title: "Pré-requisitos para Cadastro",
        description: "Identificadores obrigatórios",
        icon: "CheckCircle",
        type: "navigation",
        level: 4,
        parentStep: "ugpesq-rede-pesquisa",
        showBreadcrumbs: true,
        fields: [
          {
            id: "prerequisitos-list",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "orcid",
                type: "link",
                label: "ORCID - Criar Identificador",
                description: "Identificador único internacional (0000-0002-0123-208X)",
                emoji: "🆔",
                url: "https://orcid.org/"
              },
              {
                id: "lattes",
                type: "link",
                label: "Currículo Lattes CNPq",
                description: "Sistema nacional obrigatório no Brasil",
                emoji: "📋",
                url: "https://lattes.cnpq.br/"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - Modelos de Documentos
      {
        id: "ugpesq-modelos",
        title: "Modelos de Documentos",
        description: "Templates padronizados EBSERH",
        icon: "FileText",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-docs",
        showBreadcrumbs: true,
        fields: [
          {
            id: "modelos-navigation",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "projeto-pesquisa",
                type: "link",
                label: "Projeto de Pesquisa - Template",
                description: "Modelo completo com todas as seções",
                emoji: "📋",
                url: "https://docs.google.com/document/d/1VVWTZSxO4XaroNKuPJWiFQYpmpL2dc5W/edit"
              },
              {
                id: "planilha-orcamento",
                type: "link",
                label: "Planilha Orçamentária",
                description: "Detalhamento de custos do projeto",
                emoji: "💰",
                url: "https://docs.google.com/document/d/1qHcvZs_mU0cr_nVvQaHmkxf5FMBKE-QK/edit"
              },
              {
                id: "cronograma",
                type: "link",
                label: "Cronograma do Projeto",
                description: "Planejamento temporal com marcos",
                emoji: "📅",
                url: "https://docs.google.com/document/d/1l1ZlBHv1j5w_fRaB486RmwNi_Vt5cvNQ/edit"
              },
              {
                id: "tcud",
                type: "link",
                label: "TCUD - Utilização de Dados",
                description: "Termo obrigatório para dados pessoais",
                emoji: "🔒",
                url: "https://docs.google.com/document/d/1uZGspHu308uRB-pWsboqB2kkv_9B7UOP/edit"
              },
              {
                id: "tcle-maiores",
                type: "link",
                label: "TCLE - Maiores 18 anos",
                description: "Termo de Consentimento para adultos",
                emoji: "📝",
                url: "https://docs.google.com/document/d/1B5qVgn_oHdTyuyNyiNlB1B1PsKHtq94b/edit"
              },
              {
                id: "tcle-menores",
                type: "link",
                label: "TCLE - Menores 18 anos",
                description: "TCLE com termo de assentimento",
                emoji: "👶",
                url: "https://docs.google.com/document/d/1G6aQUvFev4IrguHvnLDxzgtxD6SvPRtn/edit"
              },
              {
                id: "termo-anuencia",
                type: "link",
                label: "Termo de Anuência",
                description: "Autorização da unidade hospitalar",
                emoji: "✅",
                url: "https://docs.google.com/document/d/1GD8tZMjZp5ty0dxmgKftPGK1RznCPzjX/edit"
              },
              {
                id: "solicitar-modelos",
                type: "contact",
                label: "Solicitar Outros Modelos",
                description: "Precisa de outro modelo?",
                emoji: "✉️",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📄%0A%0APreciso%20de%20*modelos%20de%20documentos*%20para%20minha%20pesquisa.%0A%0A📋%20*Documentos%20que%20preciso:*%0A[%20]%20TCLE%20específico%20para:%20%0A[%20]%20Termo%20de%20Assentimento%0A[%20]%20Carta%20de%20anuência%0A[%20]%20Declaração%20de%20responsabilidade%0A[%20]%20Outro:%20%0A%0A🔬%20*Sobre%20minha%20pesquisa:*%0A•%20Título:%20%0A•%20População:%20%0A•%20Tipo%20de%20estudo:%20%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - Fluxogramas
      {
        id: "ugpesq-fluxogramas",
        title: "Fluxogramas de Processo",
        description: "Diagramas visuais",
        icon: "Activity",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-docs",
        showBreadcrumbs: true,
        fields: [
          {
            id: "fluxogramas-navigation",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "fluxo-etapa1",
                type: "link",
                label: "Etapa 1 - Cadastro e Credenciamento",
                description: "Processo de cadastro inicial",
                emoji: "1️⃣",
                url: "https://drive.google.com/file/d/1cQ-sXgdtb9vbHtJzPUQ5NPlKQWRKe2em/view"
              },
              {
                id: "fluxo-etapa2",
                type: "link",
                label: "Etapa 2 - Autorização para Pesquisa",
                description: "Obtenção de carta de anuência",
                emoji: "2️⃣",
                url: "https://drive.google.com/file/d/1tkn9IJAer5eKBJY4Z2qCoQPN21ykXHB5/view"
              },
              {
                id: "fluxo-etapa3",
                type: "link",
                label: "Etapa 3 - Execução e Comunicação",
                description: "Condução e comunicação de resultados",
                emoji: "3️⃣",
                url: "https://drive.google.com/file/d/1GG3lc5sjh_jU1B7Pcf7m_2FhaYzRIsTa/view"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - Manuais Técnicos
      {
        id: "ugpesq-manuais",
        title: "Manuais Técnicos e Normativos",
        description: "Documentação oficial",
        icon: "Book",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-docs",
        showBreadcrumbs: true,
        fields: [
          {
            id: "manuais-navigation",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "manual-cep-plataforma",
                type: "link",
                label: "Manual CEP Plataforma Brasil V.3.3",
                description: "Guia para membros de CEP",
                emoji: "📘",
                url: "https://conselho.saude.gov.br/images/Manual_do_CEP_Plataforma_Brasil-Versao-3.3.pdf"
              },
              {
                id: "manual-pesquisador",
                type: "link",
                label: "Manual do Pesquisador V.3.2",
                description: "Tutorial para submissão de projetos",
                emoji: "💻",
                url: "https://conselho.saude.gov.br/images/1.1_-Manual_Pesquisador-_Vers%C3%A3o_3.3.PDF"
              },
              {
                id: "manual-cep-ufu",
                type: "link",
                label: "Manual CEP UFU 2024",
                description: "Cartilha específica da UFU",
                emoji: "🎓",
                url: "http://www.propp.ufu.br/sites/propp.ufu.br/files/media/documento/2024_cartilha_de_orientacoes_cep_ufu_ambiente_virtual.pdf"
              },
              {
                id: "manual-falabr",
                type: "link",
                label: "Manual Fala.BR 2020",
                description: "Sistema de ouvidoria",
                emoji: "📢",
                url: "https://www.ufpb.br/acessoainformacao/contents/documentos/manual_falabr_guia_usuariomoduloacessoainformacao.pdf"
              },
              {
                id: "guia-boas-praticas",
                type: "link",
                label: "Boas Práticas Clínicas ICH E6",
                description: "Padrão internacional de qualidade",
                emoji: "🌍",
                url: "https://www.gov.br/anvisa/pt-br/centraisdeconteudo/publicacoes/medicamentos/publicacoes-sobre-medicamentos/guia-de-boas-praticas-clinicas-ich-e6-r2/view"
              },
              {
                id: "resolucao-466",
                type: "link",
                label: "Resolução CNS 466/2012",
                description: "Marco regulatório brasileiro",
                emoji: "⚖️",
                url: "https://conselho.saude.gov.br/resolucoes/2012/Reso466.pdf"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGPESQ Apoio
      {
        id: "ugpesq-apoio",
        title: "Núcleo de Apoio ao Pesquisador",
        description: "Suporte científico",
        icon: "Users",
        type: "navigation",
        level: 2,
        parentStep: "ugpesq-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "apoio-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "mentoria-pesquisa",
                type: "contact",
                label: "Mentoria em Pesquisa",
                description: "Orientação para residentes\nSeg 8h-9h30 | Ter 13h-14h30",
                emoji: "🎓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20👋%0A%0AEstava%20navegando%20pelo%20SGPITS%20e%20vi%20que%20vocês%20oferecem%20*Mentoria%20em%20Pesquisa*.%0A%0A📅%20Vi%20que%20os%20horários%20disponíveis%20são:%0A•%20Segundas%208h-9h30%0A•%20Terças%2013h-14h30%0A%0AGostaria%20de%20reservar%20um%20horário%20para%20discutir%20meu%20projeto%20de%20pesquisa.%0A%0A📝%20*Meus%20dados:*%0A•%20Nome:%20%0A•%20Vínculo%20com%20o%20HC:%20%0A•%20Área%20da%20pesquisa:%20%0A•%20Principal%20dúvida:%20%0A%0A📍%20Local:%20Bloco%208F%20-%20Campus%20Umuarama%0A%0APor%20favor,%20me%20informem%20qual%20data%20teria%20disponibilidade.%0A%0AAguardo%20retorno.%20Obrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  address: "Bloco 8F - Campus Umuarama",
                  hours: "Seg 8h-9h30 | Ter 13h-14h30"
                }
              },
              {
                id: "mentoria-estatistica",
                type: "contact",
                label: "Assessoria Estatística",
                description: "Profa. Nadia Biase\nTerças à tarde",
                emoji: "📊",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20😊%0A%0ANavegando%20pelo%20SGPITS,%20encontrei%20o%20serviço%20de%20*Assessoria%20em%20Análise%20Estatística*%20com%20a%20Profa.%20Nadia%20Giaretta%20Biase.%0A%0A📅%20Entendi%20que%20o%20atendimento%20é%20às%20terças-feiras%20à%20tarde.%0A%0AGostaria%20de%20agendar%20uma%20consultoria%20pois%20preciso%20de%20suporte%20em:%0A%0A📊%20*Tipo%20de%20análise%20necessária:*%0A[%20]%20Desenho%20amostral%0A[%20]%20Escolha%20de%20testes%20estatísticos%0A[%20]%20Análise%20descritiva%0A[%20]%20Análise%20inferencial%0A[%20]%20Modelagem%0A[%20]%20Outro:%20%0A%0A💻%20*Software%20que%20utilizo:*%0A[%20]%20R%0A[%20]%20SPSS%0A[%20]%20SAS%0A[%20]%20Excel%0A[%20]%20Outro:%20%0A%0A📝%20*Sobre%20minha%20pesquisa:*%0A•%20Área:%20%0A•%20Tipo%20de%20estudo:%20%0A•%20Tamanho%20da%20amostra:%20%0A%0APodemos%20agendar%20uma%20consultoria?%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  hours: "Terças à tarde (agendamento)"
                }
              },
              {
                id: "biblioteca-apoio",
                type: "link",
                label: "Biblioteca HC-UFU",
                description: "Bases de dados e normatização",
                emoji: "📚",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/biblioteca-hc-ufu/sobre-a-biblioteca-hc-ufu"
              },
              {
                id: "treinamentos-agendamento",
                type: "link",
                label: "Agendar Treinamentos",
                description: "Capacitações personalizadas",
                emoji: "🎯",
                url: "https://forms.gle/W3X1VAHpEE7BjHXm7"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGPESQ",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGPESQ Pesquisa Patrocinada
      {
        id: "ugpesq-patrocinada",
        title: "Pesquisa Patrocinada",
        description: "Estudos com financiamento externo",
        icon: "Briefcase",
        type: "navigation",
        level: 2,
        parentStep: "ugpesq-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "patrocinada-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "info-institucional",
                type: "link",
                label: "Informações Institucionais HC-UFU",
                description: "História, estrutura e certificações\n500+ leitos, referência para 3 milhões",
                emoji: "🏥",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/acesso-a-informacao/institucional/sobre"
              },
              {
                id: "sistema-patrocinada",
                type: "link",
                label: "Sistema para Estudos Patrocinados",
                description: "Portal específico da Rede de Pesquisa",
                emoji: "💉",
                url: "https://sig.ebserh.gov.br/redepesquisa/"
              },
              {
                id: "direitos-participantes",
                type: "link",
                label: "Direitos dos Participantes",
                description: "Cartilha CONEP em linguagem acessível",
                emoji: "👥",
                url: "https://conselho.saude.gov.br/images/comissoes/conep/img/boletins/Cartilha_Direitos_Participantes_de_Pesquisa_2020.pdf"
              },
              {
                id: "info-patrocinada",
                type: "contact",
                label: "Informações sobre Pesquisa Patrocinada",
                description: "Orientações para submissão de projetos",
                emoji: "💰",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20👋%0A%0AEstou%20interessado(a)%20em%20desenvolver%20uma%20*Pesquisa%20Patrocinada*%20no%20HC-UFU.%0A%0A💼%20*Sobre%20o%20projeto:*%0A•%20Área%20terapêutica:%20%0A•%20Tipo%20de%20estudo:%20%0A•%20Patrocinador:%20%0A•%20Fase%20do%20estudo:%20%0A%0A📋%20*Preciso%20de%20orientações%20sobre:*%0A[%20]%20Documentação%20necessária%0A[%20]%20Fluxo%20de%20aprovação%0A[%20]%20Taxas%20e%20custos%0A[%20]%20Infraestrutura%20disponível%0A[%20]%20Equipe%20de%20apoio%0A%0APodemos%20agendar%20uma%20reunião%20para%20discutir%20os%20detalhes?%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  phone: "(34) 3218-2323"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGPESQ",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGPESQ Cursos
      {
        id: "ugpesq-cursos",
        title: "Cursos e Capacitações",
        description: "Formação continuada",
        icon: "Book",
        type: "navigation",
        level: 2,
        parentStep: "ugpesq-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "cursos-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "cursos-fiocruz",
                type: "navigate",
                label: "Cursos Fiocruz",
                description: "Cursos gratuitos com certificação",
                emoji: "🎓",
                targetStep: "ugpesq-cursos-fiocruz"
              },
              {
                id: "cursos-unasus",
                type: "navigate",
                label: "Cursos UNA-SUS",
                description: "⚠️ Inscrições até 10/02/2025!",
                emoji: "🏥",
                targetStep: "ugpesq-cursos-unasus",
                badge: "Prazo Limitado!",
                variant: "warning"
              },
              {
                id: "cursos-disponiveis",
                type: "contact",
                label: "Informações sobre Cursos",
                description: "Dúvidas sobre capacitações",
                emoji: "📚",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📚%0A%0AEstou%20interessado(a)%20nos%20*Cursos%20e%20Capacitações*%20oferecidos%20pela%20UGPESQ.%0A%0AGostaria%20de%20informações%20sobre:%0A•%20Cursos%20disponíveis%20atualmente%0A•%20Calendário%20de%20próximas%20turmas%0A•%20Modalidade%20(presencial/online)%0A•%20Carga%20horária%0A•%20Certificação%0A%0A📝%20*Tenho%20interesse%20especial%20em:*%0A[%20]%20Metodologia%20científica%0A[%20]%20Boas%20práticas%20em%20pesquisa%0A[%20]%20Escrita%20científica%0A[%20]%20Análise%20de%20dados%0A[%20]%20Ética%20em%20pesquisa%0A%0AMeu%20vínculo%20com%20o%20HC:%20%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGPESQ",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - Cursos Fiocruz
      {
        id: "ugpesq-cursos-fiocruz",
        title: "Cursos Fiocruz",
        description: "Plataforma de ensino a distância",
        icon: "Monitor",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-cursos",
        showBreadcrumbs: true,
        fields: [
          {
            id: "fiocruz-list",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "metodologia-cientifica",
                type: "link",
                label: "Metodologia da Pesquisa Científica",
                description: "Desenho de estudos e redação científica",
                emoji: "🔬",
                url: "https://campusvirtual.fiocruz.br/gestordecursos/hotsite/metododogia2ed"
              },
              {
                id: "divulgacao-cientifica",
                type: "link",
                label: "Divulgação Científica (MOOC)",
                description: "Comunicação científica para público geral",
                emoji: "📢",
                url: "https://campusvirtual.fiocruz.br/gestordecursos/hotsite/divulgacao-cientifica-mooc"
              },
              {
                id: "boas-praticas",
                type: "link",
                label: "Boas Práticas Clínicas Internacional",
                description: "Certificação GCP internacional",
                emoji: "🌍",
                url: "https://campusvirtual.fiocruz.br/gestordecursos/hotsite/bpc-internacional/inscreva-se/8386"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 3 - Cursos UNA-SUS
      {
        id: "ugpesq-cursos-unasus",
        title: "Cursos UNA-SUS",
        description: "⚠️ Inscrições até 10/02/2025",
        icon: "Clock",
        type: "navigation",
        level: 3,
        parentStep: "ugpesq-cursos",
        showBreadcrumbs: true,
        fields: [
          {
            id: "unasus-alert",
            type: "info",
            label: "⏰ PRAZO LIMITADO!",
            description: "Inscrições até 10/02/2025. Certificados pela UFMG. 10 horas cada.",
            icon: "AlertCircle"
          },
          {
            id: "unasus-list",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "aspectos-i",
                type: "link",
                label: "Aspectos Operacionais I - Organização",
                description: "Gestão documental em pesquisa clínica",
                emoji: "📁",
                url: "https://www.unasus.gov.br/cursos/curso/47007"
              },
              {
                id: "aspectos-ii",
                type: "link",
                label: "Aspectos Operacionais II - Estruturação",
                description: "Formação de equipe de pesquisa",
                emoji: "👥",
                url: "https://www.unasus.gov.br/cursos/curso/47008"
              },
              {
                id: "aspectos-iii",
                type: "link",
                label: "Aspectos Operacionais III - Implementação",
                description: "Ativação de centros e recrutamento",
                emoji: "🚀",
                url: "https://www.unasus.gov.br/cursos/curso/47009"
              },
              {
                id: "aspectos-iv",
                type: "link",
                label: "Aspectos Operacionais IV - Gerenciamento",
                description: "Fechamento de estudos e relatórios",
                emoji: "📊",
                url: "https://www.unasus.gov.br/cursos/curso/47010"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 1 - UGITS Principal (PIT e NATS SEPARADOS)
      {
        id: "ugits-main",
        title: "UGITS - Unidade de Gestão da Inovação Tecnológica em Saúde",
        description: "Links e informações úteis sobre inovação",
        icon: "Zap",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ugits-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "ugits-pit",
                type: "navigate",
                label: "PIT - Programa de Inovação Tecnológica",
                description: "Programa de fomento no 3º ciclo. Oferece bolsas, mentoria e recursos para projetos inovadores aplicáveis no hospital.",
                emoji: "🚀",
                targetStep: "ugits-pit",
                variant: "primary"
              },
              {
                id: "ugits-nats",
                type: "navigate",
                label: "NATS - Núcleo de Avaliação de Tecnologias",
                description: "Equipe multidisciplinar nomeada por Portaria SEI nº 131/2025.",
                emoji: "🔬",
                targetStep: "ugits-nats",
                variant: "success"
              },
              {
                id: "ugits-ferramentas",
                type: "navigate",
                label: "Ferramentas Digitais",
                description: "Soluções desenvolvidas: assistente digital, AVAQualis, DeuMatchNaPesquisa, ID-HC.",
                emoji: "🛠️",
                targetStep: "ugits-ferramentas"
              },
              {
                id: "ugits-redcap",
                type: "navigate",
                label: "REDCap",
                description: "Sistema de coleta eletrônica de dados para pesquisa. Servidor EBSERH com backup diário.",
                emoji: "📊",
                targetStep: "ugits-redcap"
              },
              {
                id: "ugits-propriedade",
                type: "navigate",
                label: "Propriedade Intelectual",
                description: "Orientação para registro de software, marca e patente no INPI.",
                emoji: "🏆",
                targetStep: "ugits-propriedade"
              },
              {
                id: "ugits-mentorias",
                type: "navigate",
                label: "Mentorias Especializadas",
                description: "Programa conjunto UGITS + UGPESQ. Atendimento no Bloco 8F.",
                emoji: "👨‍🏫",
                targetStep: "ugits-mentorias",
                badge: "Parceria UGPESQ",
                variant: "info"
              },
              { // MODIFICADO: ugits-podcast
                id: "ugits-podcast",
                type: "navigate", // MUDADO: para levar à nova tela de diálogo
                label: "Podcast HChange",
                description: "Comunicação científica temporariamente suspensa. Se quiser ajudar com edição de áudio, entre em contato!", // MUDADO: descrição atualizada
                emoji: "🎙️",
                status: "suspended",
                statusMessage: "Temporariamente suspenso",
                targetStep: "ugits-podcast-details" // MUDADO: aponta para a nova tela
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - PIT (SEPARADO)
      {
        id: "ugits-pit",
        title: "PIT - Programa de Inovação Tecnológica",
        description: "3º Ciclo em andamento",
        icon: "Rocket",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "pit-info",
            type: "info",
            label: "Programa em seu 3º Ciclo",
            description: "Atualmente em fase de seleção e com previsão para início em Setembro'25",
            icon: "Trophy"
          },
          {
            id: "pit-details",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "pit-sobre",
                type: "link",
                label: "Sobre o PIT - Site Oficial",
                description: "História, projetos aprovados e resultados",
                emoji: "📖",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/unidade-de-gestao-da-inovacao-tecnologica-em-saude/pit-hc-ufu"
              },
              {
                id: "pit-inscricao",
                type: "contact",
                label: "Como Participar do PIT",
                description: "Processo seletivo e bolsas",
                emoji: "📝",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💡%0A%0ATenho%20interesse%20no%20*PIT%20-%20Programa%20de%20Inovação%20Tecnológica*.%0A%0A🚀%20*Sobre%20minha%20ideia/projeto:*%0A•%20Nome%20do%20projeto:%20%0A•%20Área%20de%20aplicação:%20%0A•%20Problema%20que%20resolve:%20%0A•%20Estágio%20atual:%20[Ideia]%20[Protótipo]%20[MVP]%20[Produto]%0A%0A📋%20*Preciso%20de%20informações%20sobre:*%0A[%20]%20Como%20participar%20do%20programa%0A[%20]%20Critérios%20de%20seleção%0A[%20]%20Apoio%20oferecido%0A[%20]%20Próximas%20chamadas%0A[%20]%20Mentorias%20disponíveis%0A%0APodemos%20agendar%20uma%20conversa?%0A%20Obrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "pit-mentoria",
                type: "contact",
                label: "Mentoria para Projetos",
                description: "Design thinking e prototipagem",
                emoji: "💡",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGITS",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - NATS (SEPARADO)
      {
        id: "ugits-nats",
        title: "NATS - Núcleo de Avaliação de Tecnologias em Saúde",
        description: "Avaliação baseada em evidências",
        icon: "Search",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "nats-info",
            type: "info",
            label: "Portaria SEI nº 131/2025",
            description: "10 membros especialistas. Coordenação: Marcelo Batista Chioato dos Santos.",
            icon: "Shield"
          },
          {
            id: "nats-details",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "nats-sobre",
                type: "link",
                label: "Sobre o NATS",
                description: "Composição e atividades",
                emoji: "👥",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/unidade-de-gestao-da-inovacao-tecnologica-em-saude/nats"
              },
              {
                id: "nats-solicitar",
                type: "contact",
                label: "Solicitar Avaliação",
                description: "Submeter tecnologias para análise",
                emoji: "📋",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🔍%0A%0AGostaria%20de%20saber%20mais%20sobre%20o%20*NATS%20-%20Núcleo%20de%20Avaliação%20de%20Tecnologias%20em%20Saúde*.%0A%0A📊%20*Tenho%20interesse%20em:*%0A[%20]%20Submeter%20tecnologia%20para%20avaliação%0A[%20]%20Conhecer%20tecnologias%20já%20avaliadas%0A[%20]%20Participar%20como%20avaliador%0A[%20]%20Solicitar%20parecer%20técnico%0A[%20]%20Outro:%20%0A%0A💊%20*Área%20de%20interesse:*%0A•%20Medicamentos%0A•%20Equipamentos%20médicos%0A•%20Procedimentos%0A•%20Sistemas%20de%20informação%0A•%20Outro:%20%0A%0APodemos%20conversar%20melhor?%0A%0AAtenciosamente,",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGITS",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGITS Ferramentas
      {
        id: "ugits-ferramentas",
        title: "Ferramentas Digitais Desenvolvidas",
        description: "Soluções tecnológicas",
        icon: "Package",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "ferramentas-list",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "assistente-pesquisa",
                type: "link",
                label: "Assistente Digital",
                description: "Estruturação de perguntas PICO e outros",
                emoji: "🤖",
                url: "https://biblioteca-hc-ufu.vercel.app",
                badge: "Parceria Biblioteca",
                variant: "success"
              },
              { // MODIFICADO: avaqualis
                id: "avaqualis",
                type: "navigate",
                label: "AVAQualis.com",
                description: "Ferramenta mobile para acreditação",
                emoji: "📱",
                targetStep: "ugits-avaqualis-details", // Aponta para a nova tela
                status: "pilot"
              },
              { // MODIFICADO: deumatch
                id: "deumatch",
                type: "navigate", 
                label: "DeuMatchNaPesquisa",
                description: "Conecta estudantes e pesquisadores",
                emoji: "💑",
                targetStep: "ugits-deumatch-details", // Aponta para a nova tela
                status: "suspended",
                statusMessage: "⚠️ Reativando" // MUDADO
              },
              { // MODIFICADO: id-hc
                id: "id-hc",
                type: "navigate",
                label: "ID-HC",
                description: "Identificação digital religiosos",
                emoji: "🆔",
                targetStep: "ugits-idhc-details", // Aponta para a nova tela
                status: "coming-soon"
              },
              { // MODIFICADO: formulario-inovacao
                id: "formulario-inovacao",
                type: "contact",
                label: "Formulário de Monitoramento",
                description: "Informe ações inovadoras",
                emoji: "📝",
                contactInfo: { // MENSAGEM WHATSAPP ATUALIZADA
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📝%0A%0AGostaria%20de%20saber%20mais%20sobre%20o%20*Formulário%20de%20Monitoramento*%20para%20informar%20ações%20inovadoras.%0A%0AComo%20posso%20contribuir%20ou%20obter%20acesso%20a%20ele?%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGITS",
          showNext: false,
          showHome: true
        }
      },
      // --- INÍCIO DAS NOVAS TELAS DE DIÁLOGO ---
      // NÍVEL 3 - AVAQualis Details (NOVA TELA)
      {
        id: "ugits-avaqualis-details",
        title: "AVAQualis.com",
        description: "Ferramenta mobile para acreditação\n\n🧪 Em fase piloto",
        icon: "Smartphone",
        type: "navigation",
        level: 3,
        parentStep: "ugits-ferramentas",
        showBreadcrumbs: true,
        fields: [
          {
            id: "avaqualis-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-avaqualis",
                type: "link",
                label: "Acessar a Aplicação",
                description: "Visite o site oficial do AVAQualis.com",
                emoji: "🌐",
                url: "https://avaqualis.com/"
              },
              {
                id: "contact-avaqualis",
                type: "contact",
                label: "Saber Mais",
                description: "Entre em contato para detalhes sobre o projeto piloto",
                emoji: "❓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📱%0A%0AGostaria%20de%20saber%20mais%20sobre%20o%20AVAQualis.com,%20a%20ferramenta%20mobile%20para%20acreditação.%0A%0A🧪%20Como%20está%20a%20fase%20piloto?%20Como%20posso%20participar?%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: { showPrevious: true, previousButtonText: "Voltar", showNext: false, showHome: true }
      },
      // NÍVEL 3 - DeuMatchNaPesquisa Details (NOVA TELA)
      {
        id: "ugits-deumatch-details",
        title: "DeuMatchNaPesquisa",
        description: "Conecta estudantes e pesquisadores\n\n⚠️ Reativando",
        icon: "Users",
        type: "navigation",
        level: 3,
        parentStep: "ugits-ferramentas",
        showBreadcrumbs: true,
        fields: [
          {
            id: "deumatch-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-deumatch",
                type: "link",
                label: "Acessar a Aplicação",
                description: "Visite o site oficial do DeuMatchNaPesquisa.com",
                emoji: "🌐",
                url: "https://deumatchnapesquisa.com/"
              },
              {
                id: "contact-deumatch",
                type: "contact",
                label: "Saber Mais",
                description: "Entre em contato para saber sobre a reativação",
                emoji: "❓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20💑%0A%0AVi%20que%20o%20*DeuMatchNaPesquisa*%20está%20reativando.%0A%0AGostaria%20de%20ser%20avisado(a)%20quando%20estiver%20totalmente%20ativo.%20Tenho%20muito%20interesse%20na%20plataforma!%0A%0AQual%20a%20previsão%20de%20retorno?%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: { showPrevious: true, previousButtonText: "Voltar", showNext: false, showHome: true }
      },
      // NÍVEL 3 - ID-HC Details (NOVA TELA)
      {
        id: "ugits-idhc-details",
        title: "ID-HC",
        description: "Identificação digital para visitadores religiosos\n\n🔜 Em breve",
        icon: "UserCheck",
        type: "navigation",
        level: 3,
        parentStep: "ugits-ferramentas",
        showBreadcrumbs: true,
        fields: [
          {
            id: "idhc-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-idhc",
                type: "link",
                label: "Acessar a Aplicação",
                description: "Visite o site oficial do ID-HC.com",
                emoji: "🌐",
                url: "https://id-hc.com/"
              },
              {
                id: "contact-idhc",
                type: "contact",
                label: "Saber Mais",
                description: "Entre em contato para saber sobre o lançamento",
                emoji: "❓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182064&text=Olá%20Capelania!%20🙏%0A%0AFiquei%20sabendo%20sobre%20o%20*ID-HC*%20-%20Sistema%20de%20Identificação%20Digital%20para%20visitadores%20religiosos.%20Gostaria%20de%20mais%20informações%20sobre%20o%20lançamento%20e%20como%20fazer%20o%20cadastro%20antecipado.%0A%0AMeu%20nome%20é:%20%0AMinha%20instituição%20religiosa%20é:%20%0A%0AObrigado!",
                  email: "capelaniahos.hc-ufu@ebserh.gov.br",
                  phone: "(34) 3218-2064"
                }
              }
            ]
          }
        ],
        navigation: { showPrevious: true, previousButtonText: "Voltar", showNext: false, showHome: true }
      },
        // NÍVEL 2 - Podcast HChange Details (NOVA TELA)
      {
        id: "ugits-podcast-details",
        title: "Podcast HChange",
        description: "Comunicação científica temporariamente suspensa. Se você tem habilidades com edição de áudio e gostaria de ajudar a reativar o projeto, entre em contato conosco!",
        icon: "Mic",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "podcast-actions",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "access-podcast",
                type: "link",
                label: "Ouvir Episódios Anteriores",
                description: "Acesse a página oficial para ouvir os episódios já publicados.",
                emoji: "🎧",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/podcast-hchange"
              },
              {
                id: "collaborate-podcast",
                type: "contact",
                label: "Quero Ajudar a Reativar!",
                description: "Tem interesse em colaborar com edição de áudio? Fale conosco!",
                emoji: "🤝",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎙️%0A%0AEstou%20entrando%20em%20contato%20pois%20tenho%20interesse%20em%20colaborar%20para%20a%20reativação%20do%20Podcast%20HChange.%20Tenho%20habilidades%20em%20edição%20de%20áudio%20e%20gostaria%20de%20ajudar.%0A%0AMeu%20nome%20é:%20%0A%0AComo%20posso%20contribuir?",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: { showPrevious: true, previousButtonText: "Voltar para UGITS", showNext: false, showHome: true }
      },
      // --- FIM DAS NOVAS TELAS DE DIÁLOGO ---
      // NÍVEL 2 - UGITS REDCap
      {
        id: "ugits-redcap",
        title: "REDCap - Research Electronic Data Capture",
        description: "Sistema de coleta de dados",
        icon: "Database",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "redcap-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "redcap-acesso",
                type: "link",
                label: "Acessar REDCap",
                description: "Portal institucional EBSERH",
                emoji: "💻",
                url: "https://redcap.ebserh.gov.br"
              },
              {
                id: "redcap-solicitar",
                type: "contact",
                label: "Solicitar Acesso",
                description: "Criar conta para novo projeto",
                emoji: "🔐",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🔐%0A%0AGostaria%20de%20solicitar%20*acesso%20ao%20REDCap*%20para%20meu%20projeto%20de%20pesquisa.%0A%0A📋%20*Dados%20do%20pesquisador:*%0A•%20Nome%20completo:%20%0A•%20CPF:%20%0A•%20Email%20institucional:%20%0A•%20Vínculo%20com%20HC-UFU:%20%0A%0A🔬%20*Sobre%20o%20projeto:*%0A•%20Título:%20%0A•%20Pesquisador%20principal:%20%0A•%20Número%20CEP%20(se%20houver):%20%0A•%20Previsão%20de%20coleta:%20%0A%0A📊%20*Necessidades:*%0A[%20]%20Criar%20novo%20projeto%0A[%20]%20Acessar%20projeto%20existente%0A[%20]%20Treinamento%20básico%0A[%20]%20Suporte%20avançado%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "redcap-treinamento",
                type: "contact",
                label: "Treinamento REDCap",
                description: "Capacitação básica e avançada",
                emoji: "🎓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🎓%0A%0APreciso%20de%20*treinamento%20no%20REDCap*.%0A%0A📚%20*Nível%20de%20conhecimento:*%0A[%20]%20Nunca%20usei%20o%20REDCap%0A[%20]%20Uso%20básico%0A[%20]%20Intermediário%0A%0A🎯%20*Preciso%20aprender:*%0A[%20]%20Criar%20formulários%0A[%20]%20Importar/exportar%20dados%0A[%20]%20Criar%20relatórios%0A[%20]%20Configurar%20alertas%0A[%20]%20Branching%20logic%0A[%20]%20Calculated%20fields%0A[%20]%20API%0A%0A📅%20*Disponibilidade:*%0A•%20Manhã%20[%20]%20Tarde%20[%20]%0A•%20Dias%20preferenciais:%20%0A%0AQuantas%20pessoas%20do%20meu%20grupo%20precisam:%20%0A%0AObrigado!",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGITS",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGITS Propriedade Intelectual
      {
        id: "ugits-propriedade",
        title: "Propriedade Intelectual",
        description: "Proteção de inovações",
        icon: "Award",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "propriedade-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "registro-software",
                type: "link",
                label: "Registro de Software",
                description: "Fluxograma completo INPI",
                emoji: "💻",
                url: "https://www.gov.br/ebserh/pt-br/ensino-e-pesquisa/inovacao/propriedade-intelectual/anexo-i_como-solicitar-registro-de-um-software.pdf"
              },
              {
                id: "registro-marca",
                type: "link",
                label: "Registro de Marca",
                description: "Processo de registro INPI",
                emoji: "™️",
                url: "https://www.gov.br/ebserh/pt-br/ensino-e-pesquisa/inovacao/propriedade-intelectual/anexo-ii_como-solicitar-registro-de-uma-marca.pdf"
              },
              {
                id: "registro-patente",
                type: "contact",
                label: "Registro de Patente",
                description: "Orientação sem fluxo oficial",
                emoji: "🏆",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20🏆%0A%0ATenho%20uma%20invenção%20e%20gostaria%20de%20informações%20sobre%20*Registro%20de%20Patente*.%0A%0A💡%20*Sobre%20a%20invenção:*%0A•%20Área:%20%0A•%20Problema%20que%20resolve:%20%0A•%20Diferencial%20inovador:%20%0A%0A🔍%20*Status%20atual:*%0A[%20]%20Ideia%20conceitual%0A[%20]%20Protótipo%20funcional%0A[%20]%20Testes%20realizados%0A[%20]%20Pronto%20para%20produção%0A%0A📋%20*Dúvidas:*%0A[%20]%20Busca%20de%20anterioridade%0A[%20]%20Redação%20da%20patente%0A[%20]%20Custos%20do%20processo%0A[%20]%20Tempo%20de%20análise%0A[%20]%20Comercialização%0A%0APodemos%20conversar%20melhor?%0A%0AAtenciosamente,",
                  email: "ugits.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "portal-pi",
                type: "link",
                label: "Portal PI EBSERH",
                description: "Portal completo Rede EBSERH",
                emoji: "📚",
                url: "https://www.gov.br/ebserh/pt-br/ensino-e-pesquisa/inovacao/propriedade-intelectual"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGITS",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - UGITS Mentorias
      {
        id: "ugits-mentorias",
        title: "Mentorias Especializadas",
        description: "Programa conjunto UGITS + UGPESQ",
        icon: "Users",
        type: "navigation",
        level: 2,
        parentStep: "ugits-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "mentorias-info",
            type: "info",
            label: "Serviço Compartilhado",
            description: "Oferecido em parceria entre UGITS e UGPESQ",
            icon: "Info"
          },
          {
            id: "mentorias-list",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "mentoria-pesquisa",
                type: "contact",
                label: "Mentoria em Pesquisa",
                description: "Roberto Ranza e Francisco Neto\nBloco 8F",
                emoji: "🎓",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20👋%0A%0AVi%20no%20SGPITS%20que%20vocês%20oferecem%20*Mentoria%20em%20Pesquisa%20e%20Metodologia*.%0A%0A📅%20Entendi%20que%20os%20horários%20disponíveis%20são:%0A•%20Segundas%208h-9h30%0A•%20Terças%2013h-14h30%0A%0A👨‍🏫%20Com%20os%20professores:%0A•%20Roberto%20Ranza%20(UGPESQ)%0A•%20Francisco%20Diego%20Negrão%20Lopes%20Neto%20(UGITS)%0A%0A📍%20Local:%20Bloco%208F%0A%0A📝%20*Gostaria%20de%20agendar%20um%20horário%20para:*%0A[%20]%20Definir%20pergunta%20de%20pesquisa%0A[%20]%20Escolher%20metodologia%0A[%20]%20Revisar%20projeto%0A[%20]%20Discutir%20resultados%0A[%20]%20Outro:%20%0A%0A*Minha%20disponibilidade:*%0A•%20Primeira%20opção:%20%0A•%20Segunda%20opção:%20%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  address: "Bloco 8F - Campus Umuarama",
                  hours: "Seg 8h-9h30 | Ter 13h-14h30"
                }
              },
              {
                id: "mentoria-estatistica",
                type: "contact",
                label: "Consultoria Estatística",
                description: "Profa. Nadia Biase (IME/UFU)",
                emoji: "📊",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182323&text=Olá!%20📊%0A%0AVi%20que%20a%20*Profa.%20Nadia%20Giaretta%20Biase*%20oferece%20consultoria%20estatística%20às%20terças%20à%20tarde.%0A%0A📈%20*Meu%20projeto:*%0A•%20Área:%20%0A•%20Tipo%20de%20estudo:%20%0A•%20Tamanho%20amostral:%20%0A•%20Status:%20[Planejamento]%20[Coleta]%20[Análise]%0A%0A🎯%20*Preciso%20de%20ajuda%20com:*%0A[%20]%20Cálculo%20amostral%0A[%20]%20Plano%20de%20análise%0A[%20]%20Escolha%20de%20testes%0A[%20]%20Interpretação%20de%20resultados%0A[%20]%20Software%20estatístico%0A[%20]%20Outro:%20%0A%0A💻%20*Uso/pretendo%20usar:*%0A[%20]%20SPSS%0A[%20]%20R%0A[%20]%20SAS%0A[%20]%20Stata%0A[%20]%20Excel%0A%0APosso%20agendar%20uma%20consultoria?%0A%0AObrigado!",
                  email: "ugpesq.hc-ufu@ebserh.gov.br",
                  hours: "Terças à tarde (agendamento)"
                }
              },
              {
                id: "crosslink-ugpesq",
                type: "navigate",
                label: "Ver também em UGPESQ",
                description: "Disponível no Núcleo de Apoio",
                emoji: "🔄",
                targetStep: "ugpesq-apoio",
                variant: "info"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para UGITS",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 1 - Biblioteca Principal
      {
        id: "biblioteca-main",
        title: "Serviço de Biblioteca do HC-UFU/EBSERH",
        description: "Links e informações úteis",
        icon: "Book",
        type: "navigation",
        level: 1,
        parentStep: "home",
        showBreadcrumbs: true,
        fields: [
          {
            id: "biblioteca-navigation",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "biblioteca-servicos",
                type: "navigate",
                label: "Serviços e Recursos",
                description: "Acervo, empréstimo, comutação\nSala 15, segunda a sexta 7h-19h",
                emoji: "📖",
                targetStep: "biblioteca-servicos"
              },
              {
                id: "biblioteca-bases",
                type: "navigate",
                label: "Bases de Dados",
                description: "UpToDate EBSERH\nPortal CAPES",
                emoji: "🔍",
                targetStep: "biblioteca-bases"
              },
              {
                id: "biblioteca-treinamentos",
                type: "navigate",
                label: "Treinamentos",
                description: "Pesquisa bibliográfica\nNormalização ABNT",
                emoji: "🎯",
                targetStep: "biblioteca-treinamentos"
              },
              {
                id: "biblioteca-assistente",
                type: "link",
                label: "Assistente Digital",
                description: "Estruturação de perguntas",
                emoji: "🤖",
                url: "https://biblioteca-hc-ufu.vercel.app",
                badge: "Parceria UGITS",
                variant: "success"
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - Biblioteca Serviços
      {
        id: "biblioteca-servicos",
        title: "Serviços e Recursos",
        description: "Informações sobre serviços",
        icon: "Building",
        type: "navigation",
        level: 2,
        parentStep: "biblioteca-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "servicos-list",
            type: "navigation",
            navigationLayout: "list",
            navigationItems: [
              {
                id: "localizacao",
                type: "contact",
                label: "Localização e Horários",
                description: "Sala 15 - Alojamento\nSeg-Sex 7h-19h",
                emoji: "📍",
                contactInfo: {
                  address: "Sala 15 - Alojamento de Plantonistas",
                  hours: "Segunda a sexta, 7h às 19h",
                  phone: "(34) 3218-2451",
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182451&text=Olá%20Biblioteca!%20📚%0A%0AVi%20no%20sistema%20SGPITS%20que%20vocês%20funcionam%20de%20segunda%20a%20sexta,%207h%20às%2019h.%0A%0AGostaria%20de%20saber:%0A%0A📍%20Como%20chego%20na%20Sala%2015%20(Alojamento%20de%20Plantonistas)?%0A📚%20Preciso%20agendar%20para%20usar%20o%20espaço%20de%20estudo?%0A📖%20Posso%20consultar%20o%20acervo%20presencialmente?%0A%0AMeu%20nome:%20%0AMeu%20vínculo%20com%20o%20HC:%20%0A%0AObrigado!",
                  email: "seb.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "catalogo",
                type: "link",
                label: "Catálogo Online",
                description: "Busca e empréstimo",
                emoji: "📖",
                url: "https://www.gov.br/ebserh/pt-br/hospitais-universitarios/regiao-sudeste/hc-ufu/ensino-e-pesquisa/biblioteca-hc-ufu/sobre-a-biblioteca-hc-ufu"
              },
              {
                id: "comutacao",
                type: "contact",
                label: "Comutação Bibliográfica",
                description: "COMUT/SCAD - 7 dias úteis",
                emoji: "🔄",
                contactInfo: {
                  email: "seb.hc-ufu@ebserh.gov.br",
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182451&text=Olá%20Biblioteca!%20📚%0A%0APreciso%20do%20serviço%20de%20*Comutação%20Bibliográfica*%20para%20obter%20um%20documento.%0A%0A📄%20*Dados%20do%20documento:*%0A•%20Tipo:%20[Artigo]%20[Capítulo]%20[Tese]%20[Dissertação]%0A•%20Título:%20%0A•%20Autor(es):%20%0A•%20Revista/Livro:%20%0A•%20Ano:%20%0A•%20Volume/Páginas:%20%0A•%20DOI%20(se%20houver):%20%0A%0A⏰%20Entendo%20que%20o%20prazo%20médio%20é%20de%207%20dias%20úteis.%0A%0A📧%20Meu%20email%20para%20recebimento:%20%0A%0AExiste%20algum%20custo?%0A%0AObrigado!"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para Biblioteca",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - Biblioteca Bases de Dados
      {
        id: "biblioteca-bases",
        title: "Bases de Dados Científicas",
        description: "Acesso a recursos",
        icon: "Database",
        type: "navigation",
        level: 2,
        parentStep: "biblioteca-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "bases-list",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "uptodate",
                type: "link",
                label: "UpToDate EBSERH",
                description: "11.000+ tópicos clínicos",
                emoji: "💊",
                url: "https://uptodate.ebserh.gov.br/",
                variant: "primary"
              },
              {
                id: "capes",
                type: "link",
                label: "Portal CAPES",
                description: "45 mil periódicos",
                emoji: "🌐",
                url: "https://www-periodicos-capes-gov-br.ez34.periodicos.capes.gov.br/",
                variant: "success"
              },
              {
                id: "acesso-remoto",
                type: "contact",
                label: "Acesso Remoto CAFe",
                description: "Configure acesso de casa",
                emoji: "🔐",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182451&text=Olá%20Biblioteca!%20🔐%0A%0APreciso%20configurar%20o%20*Acesso%20Remoto%20CAFe*%20para%20acessar%20as%20bases%20de%20dados%20de%20casa.%0A%0A👤%20*Meus%20dados:*%0A•%20Nome:%20%0A•%20CPF:%20%0A•%20Email%20institucional:%20%0A•%20Vínculo:%20[Servidor]%20[Residente]%20[Aluno]%20[Professor]%0A%0A💻%20*Já%20tentei:*%0A[%20]%20Ainda%20não%20tentei%0A[%20]%20Segui%20o%20tutorial%20mas%20não%20funcionou%0A[%20]%20Não%20consigo%20fazer%20login%0A[%20]%20Outro%20problema:%20%0A%0A📚%20*Preciso%20acessar:*%0A[%20]%20UpToDate%0A[%20]%20Portal%20CAPES%0A[%20]%20PubMed%0A[%20]%20Outras%20bases%0A%0APode%20me%20ajudar%20com%20o%20passo%20a%20passo?%0A%0AObrigado!",
                  email: "seb.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para Biblioteca",
          showNext: false,
          showHome: true
        }
      },
      // NÍVEL 2 - Biblioteca Treinamentos
      {
        id: "biblioteca-treinamentos",
        title: "Treinamentos e Capacitações",
        description: "Desenvolva habilidades",
        icon: "Target",
        type: "navigation",
        level: 2,
        parentStep: "biblioteca-main",
        showBreadcrumbs: true,
        fields: [
          {
            id: "treinamentos-list",
            type: "navigation",
            navigationLayout: "cards",
            navigationItems: [
              {
                id: "agendamento",
                type: "link",
                label: "Agendar Capacitação",
                description: "Formulário online",
                emoji: "📝",
                url: "https://forms.gle/W3X1VAHpEE7BjHXm7"
              },
              {
                id: "pesquisa-bibliografica",
                type: "contact",
                label: "Pesquisa Bibliográfica",
                description: "Estratégias de busca",
                emoji: "🔍",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182451&text=Olá%20Biblioteca!%20🔍%0A%0AGostaria%20de%20participar%20do%20treinamento%20de%20*Pesquisa%20Bibliográfica*.%0A%0A📚%20*Meu%20nível:*%0A[%20]%20Iniciante%20-%20nunca%20fiz%20busca%20sistemática%0A[%20]%20Intermediário%20-%20já%20faço%20buscas%20básicas%0A[%20]%20Avançado%20-%20quero%20aprimorar%20estratégias%0A%0A🎯%20*Preciso%20aprender:*%0A[%20]%20Escolher%20bases%20de%20dados%0A[%20]%20Definir%20descritores%0A[%20]%20Montar%20estratégia%20de%20busca%0A[%20]%20Usar%20operadores%20booleanos%0A[%20]%20Aplicar%20filtros%0A[%20]%20Gerenciar%20referências%0A%0A👥%20*Formato%20preferido:*%0A[%20]%20Individual%0A[%20]%20Em%20grupo%0A[%20]%20Online%0A[%20]%20Presencial%0A%0A📅%20Disponibilidade:%20%0A%0AObrigado!",
                  email: "seb.hc-ufu@ebserh.gov.br"
                }
              },
              {
                id: "normalizacao",
                type: "contact",
                label: "Normalização ABNT",
                description: "Formatação de trabalhos",
                emoji: "📚",
                contactInfo: {
                  whatsapp: "https://api.whatsapp.com/send?phone=553432182451&text=Olá%20Biblioteca!%20📝%0A%0APreciso%20de%20orientação%20sobre%20*Normalização%20ABNT*.%0A%0A📚%20*Tipo%20de%20trabalho:*%0A[%20]%20Artigo%20científico%0A[%20]%20TCC%0A[%20]%20Dissertação%0A[%20]%20Tese%0A[%20]%20Relatório%20de%20pesquisa%0A[%20]%20Projeto%0A%0A❓%20*Minhas%20dúvidas%20são%20sobre:*%0A[%20]%20Citações%20e%20referências%0A[%20]%20Formatação%20geral%0A[%20]%20Estrutura%20do%20trabalho%0A[%20]%20Numeração%20de%20seções%0A[%20]%20Sumário%0A[%20]%20Elementos%20pré-textuais%0A[%20]%20Outro:%20%0A%0A📅%20Prazo%20de%20entrega:%20%0A%0APosso%20agendar%20um%20atendimento?%0A%0AObrigado!",
                  email: "seb.hc-ufu@ebserh.gov.br"
                }
              }
            ]
          }
        ],
        navigation: {
          showPrevious: true,
          previousButtonText: "Voltar para Biblioteca",
          showNext: false,
          showHome: true
        }
      }
    ]
  },
  theme: {
    primaryColor: "#6D28D9",
    primaryColorHover: "#5B21B6",
    secondaryColor: "#059669",
    secondaryColorHover: "#047857",
    pageBackground: "#f3f4f6",
    cardBackground: "#ffffff",
    inputBackground: "#ffffff",
    textPrimary: "#1f2937",
    textSecondary: "#6b7280",
    textOnPrimary: "#ffffff",
    textOnSecondary: "#ffffff",
    borderColor: "#e5e7eb",
    borderRadius: "16px",
    errorColor: "#dc2626",
    successColor: "#059669",
    warningColor: "#f59e0b",
    infoColor: "#3b82f6",
    buttonStyle: "rounded",
    buttonPadding: "16px 32px",
    buttonFontWeight: "700",
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: "16px",
    headingFontFamily: '"Inter", sans-serif',
    headingFontWeight: "800",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    boxShadowHover: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    transitionDuration: "0.3s",
    progressBarColor: "linear-gradient(90deg, #6D28D9 0%, #059669 100%)",
    progressBarBackground: "#e5e7eb",
    logoBackground: "transparent",
    logoPadding: "16px",
    logoBorderRadius: "12px"
  }
};